import React, { useState } from 'react';
import spfDetail from '../../Images/ProjectImages/7point5Details.png'
import twitchDetails from '../../Images/ProjectImages/TwitcheckDetails.png'
import mlgmDetails from '../../Images/ProjectImages/MLGMDetails.png'
import algoDetails from '../../Images/LogoImages/Graphs.png'
import terminalDetails from '../../Images/ProjectImages/TerminalDetails.png'
import highlanderDetails from '../../Images/ProjectImages/HighlanderDetails.png'
import modernsenseDetails from '../../Images/ProjectImages/ModernSenseDetails.png'
import fplDetails from '../../Images/ProjectImages/FPLDetails.png'

const projectsData = [
  {
    name: "Fuecoco's Premier League",
    description: "An invite-only Pokémon draft league platform built for a group of competitive players. Members draft Pokémon within a points cap, compete in head-to-head matches, and track results across a full season. Features a live draft board with real-time sync, match reporting with per-Pokémon battle logs, trade tracking, standings, a double-elimination playoff bracket, and a Hall of Fame. Built to match the polish of apps like Sleeper and ESPN.",
    image: fplDetails,
    technologies: ["Next.js", "TypeScript", "Supabase"],
    url: "https://fpl.wjtim.com"
  },
  {
    name: "MLGM",
    description: "A machine learning pipeline that predicts NHL skater stats for the upcoming season. Scrapes 15 seasons of historical player and team data from the official NHL API, engineers features including 5-year rolling averages and year-over-year trends, then trains 10 separate XGBoost regression models — split by position — to forecast goals, assists, shots, hits, and blocks. Uses time-based cross-validation and Optuna hyperparameter tuning to avoid data leakage.",
    image: mlgmDetails,
    technologies: ["Python", "XGBoost"],
    url: "https://github.com/wjtim/MLGM"
  },
  {
    name: "ModernSense",
    description: "A Python and Flask application that applies ML sentiment analysis models to user input data. The user can either manually enter a review and rating, or upload a batch of reviews and ratings via csv. The model will analyze the sentiment of the input review and determine whether it accurately matches the rating given. ",
    image: modernsenseDetails,
    technologies: ["Python", "Flask"],
    url: "https://github.com/wjtim/modernSense"
  },
  {
    name: "WJTIM Highlander",
    description: "I wanted to try my hand with real time interaction, as well as creating a game, and dabbling in noSQL. This project was a perfect mix of all 3. WJTIM Highlander is a simple game where the most current name input is added to a firestore database, then the time it was recorded is monitored with a timer. Whenever a name is replaced if it was in the top 5 longest times before it was replaced it gets added to a leaderboard.This is definitely my most interactive project and for sure one of the most fun to have live.",
    image: highlanderDetails,
    technologies: ["React", "Firebase", "JavaScript"],
    url: "https://highlander.wjtim.com/"
  },
  {
    name: "7point5",
    description: "A full stack web application made with PostgreSQL, Express, React, and Node. Thisweb application is a password protected site where events are reviewed using FormData which is digested by the back end, stored, then displayed on the site. It is hosted on an Amazon EC2 instance with image hosting done in an Amazon S3 Bucket. This project was my first full stack project and allowed me to experience tons of useful techniques from AWS Hosting, to JSON Web Tokens, Encryption and much more.",
    image: spfDetail,
    technologies: ["React", "Node", "PostgreSQL", "AWS"],
    url: "http://7point5.club/"
  },
  {
    name: "Twitcheck",
    description: "A small django application made to test out using other API's. In this case, the Twitch API. Simply put in the name of a streamer, and depending on whether they are online will either play their current livestream for you,or let you know that they are offline.",
    image: twitchDetails,
    technologies: ["Django", "Python"],
    url: "https://twitcheck.fly.dev/"
  },
  {
    name: "Algorithms",
    description: "This was an excercise to practice a few skills. I wanted to do something that would allow me to reuse my knowledge of data structures and algorithms as well as have a chance to create outputs using Python and Matplotlib.",
    image: algoDetails,
    technologies: ["Python"],
    url: "https://wjtim.com/algorithms"
  },
  {
    name: "The Terminal",
    description: "Once I saw the react-console-emulator library, given the terminal theming of this site, I knew I wanted to create a fun interactive experience where I could hide easter eggs and give a trivial command line experience in a fun environment on this site.",
    image: terminalDetails,
    technologies: ["React", "JavaScript"],
    url: "https://wjtim.com/terminal"

  },
];

const Project = ({ name, description, image, url, technologies }) => {
  return (
    <div className="mx-3 my-6 p-7 border border-gray-200 rounded-xl shadow-sm hover:shadow-md hover:translate-y-[-3px] transform transition-all duration-300">
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="md:w-1/4 flex-shrink-0 h-40 rounded-lg flex items-center justify-center">
          <img src={image} alt={name} className="max-h-full max-w-full object-contain rounded-lg shadow-sm" />
        </div>
        <div className="md:w-3/4 flex flex-col justify-between gap-3">
          <div>
            <a href={url} target="_blank" rel="noopener noreferrer"
              className="text-xl font-mono font-semibold hover:text-orange-500 transition-colors duration-200">
              {name} <span className="text-orange-500">↗</span>
            </a>
            <p className="font-mono text-sm text-gray-600 mt-2 leading-relaxed">{description}</p>
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {technologies.map(tech => (
              <span key={tech} className="font-mono text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded-md">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const ProjectsPage = () => {
  const [selectedTech, setSelectedTech] = useState("All");

  const uniqueTechnologies = ["All", ...Array.from(new Set(projectsData.flatMap(p => p.technologies))).sort()];

  const filteredProjects = selectedTech === "All"
    ? projectsData
    : projectsData.filter(p => p.technologies.includes(selectedTech));

  return (
    <div>
      <div className="text-2xl font-mono pr-1 my-5 mx-3">{"> About My Projects:"}</div>

      <div className="mx-3 mt-4 mb-8 flex flex-wrap gap-2">
        {uniqueTechnologies.map(tech => (
          <button
            key={tech}
            onClick={() => setSelectedTech(tech)}
            className={`font-mono text-sm px-3 py-1 rounded-full border transition-colors duration-200 ${
              selectedTech === tech
                ? 'bg-orange-500 text-white border-orange-500'
                : 'bg-white text-gray-600 border-gray-300 hover:border-orange-400 hover:text-orange-500'
            }`}
          >
            {tech}
          </button>
        ))}
      </div>

      {filteredProjects.map((project, index) => (
        <Project
          key={index}
          name={project.name}
          description={project.description}
          image={project.image}
          url={project.url}
          technologies={project.technologies}
        />
      ))}
    </div>
  );
};

export default ProjectsPage;
